export default __webpack_public_path__ + "static/media/brushes.fe3782cf.jpg";